<style lang="less" scoped>
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.content {
  .contentTitle {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #edeef1;
    padding: 0 30px;
    color: #000000;
    font-size: 16px;
    font-weight: 600;
  }
  .member-list {
    padding: 0 20px;
    margin-top: 8px;
    min-height: 560px;
    .member-li {
      display: flex;
      justify-content: space-between;
      padding: 12px 0;
      border-bottom: 1px solid #edeef1;
      line-height: 35px;
      .left {
        display: flex;
        .photo {
          width: 32px;
          height: 32px;
          border-radius: 4px;
          margin-top: -6px;
        }
        .name {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 24px;
          margin-left: 10px;
        }
      }
      .right {
        text-align: right;
        color: @primary-color;
        .zb {
          cursor: pointer;
          margin-right: 10px;
        }
        .yc {
          cursor: pointer;
        }
      }
    }
  }
  .page {
    text-align: center;
    margin-top: 20px;
  }
}
/deep/.ant-modal-footer {
  text-align: center;
  border-top: none;
}
.del-name {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #040506;
  line-height: 24px;
  text-align: center;
}
</style>
<template>
  <div class="content">
    <div class="contentTitle">班级成员</div>
    <ul class="member-list">
      <li class="member-li" v-for="(item, index) in studentList" :key="index">
        <div class="left">
          <img v-show="item.isTea === 0" class="photo" :src="item.photo&&item.photo!==null ?resBasePath+'/'+ item.photo : 'imgs/student.png'" alt="" />
          <img v-show="item.isTea === 1" class="photo" :src="item.photo&&item.photo!==null ?resBasePath+'/'+ item.photo : 'imgs/teacher.png'" alt="" />
          <span class="name">{{ item.userName }}</span>
        </div>
        <div class="right" v-if="item.isTea === 0">
          <span class="zb" @click="zbFun(item)">转班</span>
          <span class="yc" @click="ycFun(item)">移除</span>
        </div>
      </li>
    </ul>
    <div class="page">
      <a-config-provider>
        <a-pagination
          show-quick-jumper
          @change="changePageNum"
          :total="total"
        />
      </a-config-provider>
    </div>
    <a-modal
      title="转班"
      width="460px"
      :visible="zbVis"
      @cancel="classCancel"
      @ok="classOk"
    >
      <template>
        <div>
          <span>转入班级</span>
          <a-select
            style="width: 320px; margin-left: 20px"
            placeholder="请输入您要转入的班级"
            @change="classChange"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in classData"
              :key="index"
            >
              {{ item.className }}
            </a-select-option>
          </a-select>
        </div>
      </template>
    </a-modal>
    <a-modal
      title="移除"
      width="460px"
      :visible="ycVis"
      @cancel="ycCancel"
      @ok="ycOk"
    >
      <template>
        <div class="del-name">是否把{{ zbMess.userName }}移除该班级？</div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import requestUrl from '../../../utils/requestUrl.js'
export default {
  name: 'Member',
  data () {
    return {
      resBasePath: this.$userINfoBasePath,
      requestUrl,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      studentList: [],
      zbVis: false,
      ycVis: false,
      access_token: this.$store.state.access_token,
      currentClassId: this.$store.state.currentClassId,
      zbMess: {},
      classData: this.$store.state.classList,
      inClassId: '',
      userId: this.$store.state.userId||JSON.parse(localStorage.getItem('user_info')).id
    }
  },
  computed: {
    getCurrentClassId () {
      return this.$store.state.currentClassId
    }
  },
  watch: {
    getCurrentClassId (val) {
      this.currentClassId = val
      this.getList()
    }
  },
  mounted () {
    if (this.$store.getters.currentClass) {
      this.getList()
    }
  },
  methods: {
    getList () {
      const param = {
        access_token: this.access_token,
        classId: this.currentClassId
      }
      this.$http.post(requestUrl.getClaMembersByClassId, param).then((res) => {
        this.studentList = res
        this.total = res.length
      })
    },
    changePageNum (e) {
      console.log(e)
    },
    zbFun (item) {
      this.zbMess = item
      this.zbVis = true
    },
    ycFun (item) {
      this.zbMess = item
      this.ycVis = true
    },
    classChange (e) {
      this.inClassId = e
    },
    classCancel () {
      this.zbVis = false
    },
    classOk () {
      const param = {
        access_token: this.access_token,
        userId: this.zbMess.id, // 用户id
        classId: this.$store.state.currentClassId, // 当前的班级ID
        changeClassId: this.inClassId // 要转入的班级ID
      }
      this.$http.post(requestUrl.classStuOfChange, param).then((res) => {
        if (res) {
          this.$message.success('转班成功')
          this.getList()
          this.getClassList()
        }
      })
      this.zbVis = false
    },
    ycCancel () {
      this.ycVis = false
    },
    ycOk () {
      const param = {
        access_token: this.access_token,
        userId: this.zbMess.id,
        classId: this.$store.state.currentClassId
      }
      this.$http.post(requestUrl.delClassStu, param).then((res) => {
        if (res) {
          this.ycVis = false
          this.$message.success('删除成功')
          this.getList()
          this.getClassList()
        }
      })
    },
    getClassList () {
      this.$http.post('ebook/res/class/getClassList', {
          access_token: this.access_token,
          userId: this.userId
      }).then((res) => {
        if (res) {
          this.$store.commit('setClassList', res)
        }
      })
    },
  }
}
</script>
